function updateHeaderCartCount(count) {
  var display = count < 10 ? '0' + count : String(count);
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.textContent = display;
  });
}


if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event.cartData && typeof event.cartData.item_count !== 'undefined') {
      updateHeaderCartCount(event.cartData.item_count);
    }
  });
}


document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('[data-product-kactus]');
  if (!section) return;

  // ── GALERIE ──────────────────────────────────────────────
  var allItems  = Array.from(section.querySelectorAll('[data-media-item]'));
  var allThumbs = Array.from(section.querySelectorAll('[data-thumb]'));
  var prevBtn   = section.querySelector('[data-gallery-prev]');
  var nextBtn   = section.querySelector('[data-gallery-next]');

  var visible = allItems.slice(); // par défaut : tout visible
  var current = 0;

  function showIndex(idx) {
    current = (idx + visible.length) % visible.length;

    // Masque tout, affiche le courant
    allItems.forEach(function (el) { el.style.display = 'none'; el.classList.remove('is-active'); });
    visible[current].style.display = 'block';
    visible[current].classList.add('is-active');

    // Lecture vidéo si c'est une vidéo
    var vid = visible[current].querySelector('video');
    if (vid) { vid.play(); }

    // Sync thumbnails
    allThumbs.forEach(function (t) { t.classList.remove('is-active'); });
    var activeOrigIdx = parseInt(visible[current].dataset.index, 10);
    var matchThumb = allThumbs.find(function (t) {
      return parseInt(t.dataset.index, 10) === activeOrigIdx;
    });
    if (matchThumb) matchThumb.classList.add('is-active');
  }

  function filterByColor(color) {
    var colorLower = color ? color.toLowerCase() : null;

    visible = allItems.filter(function (item) {
      if (!colorLower) return true;
      var alt = (item.dataset.alt || '').toLowerCase();
      // Affiche si alt vide OU si alt contient la couleur
      return alt === '' || alt.includes(colorLower);
    });

    if (!visible.length) visible = allItems; // fallback

    // Masque les thumbs non visibles
    allThumbs.forEach(function (t) {
      var origIdx = parseInt(t.dataset.index, 10);
      var inVisible = visible.some(function (el) {
        return parseInt(el.dataset.index, 10) === origIdx;
      });
      t.style.display = inVisible ? 'block' : 'none';
    });

    // Flèches
    if (prevBtn) prevBtn.style.display = visible.length > 1 ? 'flex' : 'none';
    if (nextBtn) nextBtn.style.display = visible.length > 1 ? 'flex' : 'none';

    showIndex(0);
  }

  // Flèches
  if (prevBtn) prevBtn.addEventListener('click', function () { showIndex(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showIndex(current + 1); });

  // Swipe tactile (mobile)
  var galleryMain = section.querySelector('[data-gallery-main]');
  if (galleryMain) {
    var touchStartX = 0;
    var touchStartY = 0;
    var SWIPE_THRESHOLD = 40; // px minimum pour compter comme un swipe

    galleryMain.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    galleryMain.addEventListener('touchend', function (e) {
      var touchEndX = e.changedTouches[0].screenX;
      var touchEndY = e.changedTouches[0].screenY;
      var deltaX = touchEndX - touchStartX;
      var deltaY = touchEndY - touchStartY;

      if (Math.abs(deltaX) < Math.abs(deltaY)) return;
      if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;

      if (deltaX < 0) {
        showIndex(current + 1);
      } else {
        showIndex(current - 1);
      }
    }, { passive: true });
  }

  // Thumbnails
  allThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var origIdx = parseInt(this.dataset.index, 10);
      var newIdx  = visible.findIndex(function (el) {
        return parseInt(el.dataset.index, 10) === origIdx;
      });
      if (newIdx >= 0) showIndex(newIdx);
    });
  });

  // ── VARIANTS ─────────────────────────────────────────────
  var data = window.__productData;
  if (!data) { filterByColor(null); return; }

  var variants      = data.variants;
  var colorIdx      = data.colorOptionIndex;
  var sizeIdx       = data.sizeOptionIndex;
  var selectedColor = null;
  var selectedSize  = null;

  var firstAvailable = variants.find(function (v) { return v.available; }) || variants[0];
  var initialVariant = data.selectedVariantId
    ? variants.find(function (v) { return v.id === data.selectedVariantId; })
    : null;
  initialVariant = initialVariant || firstAvailable;

  if (initialVariant) {
    selectedColor = initialVariant.options[colorIdx] || null;
    selectedSize  = sizeIdx >= 0 ? (initialVariant.options[sizeIdx] || null) : null;
  }

  var variantIdInput = section.querySelector('[data-variant-id]');
  var priceEl        = section.querySelector('[data-product-price]');

  function findVariant(color, size) {
    return variants.find(function (v) {
      var cOk = !color || v.options[colorIdx] === color;
      var sOk = sizeIdx < 0 || !size || v.options[sizeIdx] === size;
      return cOk && sOk;
    }) || null;
  }

  var addToCartBtn = section.querySelector('[data-add-to-cart]');
  var buyNowBtn    = section.querySelector('[data-buy-now]');
  var availabilityEl = section.querySelector('[data-availability]');

  function updateVariant() {
    var v = findVariant(selectedColor, selectedSize);
    if (!v) return;
    if (variantIdInput) variantIdInput.value = v.id;
    if (priceEl) {
      var formattedPrice = data.variantPrices && data.variantPrices[v.id];
      priceEl.textContent = formattedPrice || (Math.round(v.price / 100) + '€');
    }

    // Active/désactive les boutons d'achat
    if (addToCartBtn) addToCartBtn.disabled = !v.available;
    if (buyNowBtn) buyNowBtn.disabled = !v.available;

    // Met à jour le badge disponibilité
    if (availabilityEl) {
      var badgeTextEl = availabilityEl.querySelector('[data-availability-text]');
      var isPreorder = availabilityEl.dataset.availability === 'orange';
      if (!isPreorder) {
        if (v.available) {
          availabilityEl.dataset.availability = 'green';
          if (badgeTextEl) badgeTextEl.textContent = availabilityEl.dataset.inStockText || 'In stock';
        } else {
          availabilityEl.dataset.availability = 'red';
          if (badgeTextEl) badgeTextEl.textContent = availabilityEl.dataset.outOfStockText || 'Out of stock';
        }
      }
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }

  // Buy Now — checkout direct sans passer par le panier
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      var v = findVariant(selectedColor, selectedSize);
      if (!v) return;
      window.location.href = '/cart/' + v.id + ':1';
    });
  }

  // Add to cart — fetch API → cart-notification Dawn + compteur header
  var productForm = section.querySelector('[data-product-form]');
  if (productForm) {
    var addBtn = productForm.querySelector('button[name="add"]');
    var addBtnDefaultText = addBtn ? addBtn.textContent.trim() : '';

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var v = findVariant(selectedColor, selectedSize);
      if (!v || !v.available) return;

      if (addBtn) { addBtn.disabled = true; addBtn.textContent = '...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          return Promise.all([
            fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }),
            fetch('/cart.js').then(function (r) { return r.json(); })
          ]);
        })
        .then(function (results) {
          var sections = results[0];
          var cart = results[1];

          updateHeaderCartCount(cart.item_count);

          if (sections['cart-drawer']) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');

            var emptyState = document.querySelector('.drawer__inner-empty');
            if (emptyState) emptyState.style.display = 'none';

            var newItems = doc.querySelector('#CartDrawer-CartItems');
            var curItems = document.querySelector('#CartDrawer-CartItems');
            if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

            var newFooter = doc.querySelector('.cart-drawer__footer');
            var curFooter = document.querySelector('.cart-drawer__footer');
            if (newFooter && curFooter) curFooter.innerHTML = newFooter.innerHTML;

            var checkoutBtn = document.querySelector('#CartDrawer-Checkout');
            if (checkoutBtn) checkoutBtn.disabled = false;

            var cartDrawerEl = document.querySelector('cart-drawer');
            var cartDrawerItems = document.querySelector('cart-drawer-items');
            if (cartDrawerEl) cartDrawerEl.classList.remove('is-empty');
            if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');

            if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
              cartDrawerEl.open();
            }
          }

          if (addBtn) {
            addBtn.textContent = 'Added ✓';
            setTimeout(function () {
              addBtn.disabled = false;
              addBtn.textContent = addBtnDefaultText;
            }, 1500);
          }
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtnDefaultText; }
        });
    });
  }

  function updateSizes() {
    section.querySelectorAll('[data-size-btn]').forEach(function (btn) {
      var v = findVariant(selectedColor, btn.dataset.size);
      btn.disabled = !v || !v.available;
    });
  }

  // Swatches couleur
  section.querySelectorAll('[data-swatch]').forEach(function (sw) {
    sw.addEventListener('click', function () {
      section.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-selected'); });
      this.classList.add('is-selected');
      selectedColor = this.dataset.color;
      filterByColor(selectedColor);
      updateSizes();
      updateVariant();
    });
  });

  // Boutons taille
  section.querySelectorAll('[data-size-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (this.disabled) return;
      section.querySelectorAll('[data-size-btn]').forEach(function (b) { b.classList.remove('is-selected'); });
      this.classList.add('is-selected');
      selectedSize = this.dataset.size;
      updateVariant();
    });
  });

  // Init visuel
  section.querySelectorAll('[data-swatch]').forEach(function (s) {
    s.classList.toggle('is-selected', s.dataset.color === selectedColor);
  });
  section.querySelectorAll('[data-size-btn]').forEach(function (b) {
    b.classList.toggle('is-selected', b.dataset.size === selectedSize);
  });

  filterByColor(selectedColor);
  updateSizes();
  updateVariant();
});

// ── PRELAUNCH : affiche succès si ?subscribed=true dans l'URL ──
(function () {
  if (!window.location.search.includes('subscribed=true')) return;

  var form    = document.querySelector('#PrelaunchForm');
  var success = document.querySelector('.product-kactus__prelaunch-success');

  if (form) form.style.display = 'none';
  if (success) success.hidden = false;
})();
// ── CALCULATEUR DE TAILLE ─────────────────────────────────
(function () {
  var calc = document.getElementById('SizeCalculator');
  if (!calc) return;

  // Fourchettes hauteur (cm) et poids max (kg) par taille
  var SIZES = [
    { name: 'XS', heightMax: 164, weightMax: 52  },
    { name: 'S',  heightMax: 173, weightMax: 62  },
    { name: 'M',  heightMax: 183, weightMax: 72  },
    { name: 'L',  heightMax: 192, weightMax: 82  },
    { name: 'XL', heightMax: 999, weightMax: 93  }
  ];

  var unit = 'metric';
  var unitBtns  = calc.querySelectorAll('[data-unit]');
  var labelH    = calc.querySelector('[data-label-height]');
  var labelW    = calc.querySelector('[data-label-weight]');
  var inputH    = document.getElementById('CalcHeight');
  var inputW    = document.getElementById('CalcWeight');
  var submitBtn = calc.querySelector('.size-calc__submit');
  var result    = document.getElementById('CalcResult');

  // ── Masque de saisie "5'7"" en mode impérial ──────────────
  // Le 1er chiffre = pieds, les 1-2 chiffres suivants = pouces (0-11)
  function sanitizeHeightDigits(digits) {
    digits = digits.slice(0, 3);
    if (digits.length === 3) {
      var inches = parseInt(digits.slice(1), 10);
      if (inches > 11) {
        // Le dernier chiffre tapé rendrait les pouces invalides → on l'ignore
        digits = digits.slice(0, 2);
      }
    }
    return digits;
  }

  function formatFeetInches(digits, closeQuote, allowBareFeet) {
    if (!digits) return '';
    var feet = digits.slice(0, 1);
    var inches = digits.slice(1, 3);
    if (digits.length <= 1) {
      if (allowBareFeet && !closeQuote) return feet; // en cours de suppression : reste éditable, sans ponctuation forcée
      inches = closeQuote ? '0' : '';
    }
    var out = feet + "'";
    if (inches || closeQuote) {
      out += inches + (closeQuote ? '"' : '');
    }
    return out;
  }

  function imperialHeightToCm(rawValue) {
    var digits = sanitizeHeightDigits(String(rawValue || '').replace(/\D/g, ''));
    if (!digits) return NaN;
    var feet = parseInt(digits.slice(0, 1), 10) || 0;
    var inches = digits.length > 1 ? parseInt(digits.slice(1), 10) : 0;
    return Math.round((feet * 12 + inches) * 2.54);
  }

  inputH.addEventListener('input', function (e) {
    if (unit !== 'imperial') return;
    var isDeleting = e.inputType && e.inputType.indexOf('delete') === 0;
    var digits = sanitizeHeightDigits(inputH.value.replace(/\D/g, ''));
    inputH.value = formatFeetInches(digits, false, isDeleting);
  });

  inputH.addEventListener('blur', function () {
    if (unit !== 'imperial') return;
    var digits = sanitizeHeightDigits(inputH.value.replace(/\D/g, ''));
    inputH.value = formatFeetInches(digits, true, false);
  });

  // Toggle unité
  unitBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      unit = this.dataset.unit;
      unitBtns.forEach(function (b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');
      labelH.textContent = unit === 'metric' ? 'Height (cm)' : 'Height (ft/in)';
      labelW.textContent = unit === 'metric' ? 'Weight (kg)' : 'Weight (lbs)';
      inputH.value = '';
      inputW.value = '';
      result.hidden = true;
    });
  });

  function showResult(html, isError) {
    result.innerHTML = html;
    result.hidden = false;
    result.className = 'size-calc__result' + (isError ? ' size-calc__result--error' : '');
  }

  submitBtn.addEventListener('click', function () {
    var hCm = unit === 'imperial' ? imperialHeightToCm(inputH.value) : parseFloat(inputH.value);
    var w   = parseFloat(inputW.value);

    if (!hCm || !w || hCm <= 0 || w <= 0) {
      showResult('Please fill in both fields.', true);
      return;
    }

    // Conversion du poids en kg si imperial
    var wKg = unit === 'imperial' ? Math.round(w * 0.453592) : w;

    // 1. Taille de base selon la hauteur
    var baseIndex = SIZES.length - 1;
    for (var i = 0; i < SIZES.length; i++) {
      if (hCm <= SIZES[i].heightMax) { baseIndex = i; break; }
    }

    // 2. Si poids > limite haute → monter d'une taille (max une fois en général)
    var finalIndex = baseIndex;
    while (finalIndex < SIZES.length - 1 && wKg > SIZES[finalIndex].weightMax) {
      finalIndex++;
    }

    var recommended = SIZES[finalIndex];
    var wentUp = finalIndex > baseIndex;
    var overLimit = wKg > SIZES[SIZES.length - 1].weightMax;

    var chartTrigger = '<a href="#" data-open-size-chart style="text-decoration:underline;text-underline-offset:3px;color:#111;">size chart</a>';

    var html = '';

    if (overLimit) {
      html = 'Based on your measurements, we recommend <strong>XL</strong>. Your weight is above our standard range, refer to our ' + chartTrigger + ' to confirm the fit.';
    } else {
      html = 'Based on your measurements, we recommend <strong>' + recommended.name + '</strong>. Refer to our ' + chartTrigger + ' for more precision.';
    }

    showResult(html, false);
  });

  // Délégation d'événement pour le lien size chart dans le résultat
  result.addEventListener('click', function (e) {
    var link = e.target.closest('[data-open-size-chart]');
    if (!link) return;
    e.preventDefault();
    var modal = document.getElementById('SizeChartModal');
    if (modal) modal.showModal();
  });
})();